import { Navigate} from "react-router-dom";
import { useAuth } from "../components/hooks/useAuth";
function PublicRoute({ element: Component}) {
  const { isSignedin } = useAuth();
  return !isSignedin ? Component : <Navigate to="/content-analytics" />;
}

export default PublicRoute;
